module.exports = __webpack_public_path__ + "static/home_tablet-dfbafae90a774045a779c177f6b2a156.png";